export default __webpack_public_path__ + "static/media/Share.190ba77b.png";